import { defineMessages } from '@cookbook/solid-intl'

// Split out of `vertoflex-page.messages.en.js` so the router's document-title/meta-
// description wiring doesn't have to eagerly pull that entire page's messages file
// into the boot-critical chunk just for these strings. Same pattern/rationale as
// `tos-page-routing.messages.en.js` / `privacy-page-routing.messages.en.js`
// (TENANT-5036 bundle audit).
export const messages = {
    descriptionMessage: defineMessages({
        defaultMessage: 'Learn about VertoFlex on Lodgr. Book now and pay later with flexible financing. Enjoy more control over how you pay for your stays.',
        id: 'VertoflexPage.descriptionMessage',
    }),
    titleMessage: defineMessages({
        defaultMessage: 'VertoFlex Payments | Lodgr',
        id: 'VertoflexPage.titleMessage',
    }),
}
